function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 3.63636C0 3.2347 0.335786 2.90909 0.75 2.90909H14.25C14.6642 2.90909 15 3.2347 15 3.63636C15 4.03803 14.6642 4.36364 14.25 4.36364H0.75C0.335786 4.36364 0 4.03803 0 3.63636Z",
  fill: "#FD7743"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 1.45455C5.80109 1.45455 5.61032 1.53117 5.46967 1.66756C5.32902 1.80395 5.25 1.98893 5.25 2.18182V2.90909H9.75V2.18182C9.75 1.98893 9.67098 1.80395 9.53033 1.66756C9.38968 1.53117 9.19891 1.45455 9 1.45455H6ZM11.25 2.90909V2.18182C11.25 1.60316 11.0129 1.04821 10.591 0.63904C10.169 0.229869 9.59674 0 9 0H6C5.40326 0 4.83097 0.229869 4.40901 0.63904C3.98705 1.04821 3.75 1.60316 3.75 2.18182V2.90909H2.25C1.83579 2.90909 1.5 3.2347 1.5 3.63636V13.8182C1.5 14.3968 1.73705 14.9518 2.15901 15.361C2.58097 15.7701 3.15326 16 3.75 16H11.25C11.8467 16 12.419 15.7701 12.841 15.361C13.2629 14.9518 13.5 14.3968 13.5 13.8182V3.63636C13.5 3.2347 13.1642 2.90909 12.75 2.90909H11.25ZM3 4.36364V13.8182C3 14.0111 3.07902 14.1961 3.21967 14.3324C3.36032 14.4688 3.55109 14.5455 3.75 14.5455H11.25C11.4489 14.5455 11.6397 14.4688 11.7803 14.3324C11.921 14.1961 12 14.0111 12 13.8182V4.36364H3Z",
  fill: "#FD7743"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 6.54545C6.41421 6.54545 6.75 6.87107 6.75 7.27273V11.6364C6.75 12.038 6.41421 12.3636 6 12.3636C5.58579 12.3636 5.25 12.038 5.25 11.6364V7.27273C5.25 6.87107 5.58579 6.54545 6 6.54545Z",
  fill: "#FD7743"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 6.54545C9.41421 6.54545 9.75 6.87107 9.75 7.27273V11.6364C9.75 12.038 9.41421 12.3636 9 12.3636C8.58579 12.3636 8.25 12.038 8.25 11.6364V7.27273C8.25 6.87107 8.58579 6.54545 9 6.54545Z",
  fill: "#FD7743"
});

var SvgBasket = function SvgBasket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBasket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/basket.9539c62b.svg";
export { ForwardRef as ReactComponent };